module.exports = __webpack_public_path__ + "static/media/ic_word.7a77cbf6.svg";